import clsx from 'clsx'
import React from 'react'
import { Heart } from '../../toneIcons'
import styles from './BeatingHeart.module.scss'

export const BeatingHeart: React.FC<React.HtmlHTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const classList = clsx(className, styles.heart)
  return <Heart className={classList} />
}